import { OperationsData } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { WallDisplayPage } from "../SystemPages";
import { lazyPage } from "../../lib/lazyPage";
const CompletedOperationsPage = lazyPage(() => import("../operations/ProgramLobPage"), "CompletedOperationsPage");
const GlobalSearchPage = lazyPage(() => import("../operations/ProgramLobPage"), "GlobalSearchPage");
const ProgramLobPage = lazyPage(() => import("../operations/ProgramLobPage"), "ProgramLobPage");
const WallDisplaysPage = lazyPage(() => import("../platform/WallDisplaysPage"), "WallDisplaysPage");
const SqdcPage = lazyPage(() => import("../shopfloor/SqdcPage"), "SqdcPage");

export {
  CompletedOperationsPage,
  GlobalSearchPage,
  ProgramLobPage,
  SqdcPage,
  WallDisplayPage,
  WallDisplaysPage
};

/**
 * Gate E / W9 Parity area routes (D-O86, O-R20, O-R34):
 * - /operations/program-lob (Program Line of Balance charts with division filter)
 * - /operations/completed-ops (Standalone completed operations analytics view)
 * - /search (Unified Operations global search)
 */
export const parityRoutes: AreaRoute[] = [
  {
    path: "/operations/program-lob",
    allow: OperationsData,
    element: <ProgramLobPage />
  },
  {
    path: "/operations/completed-ops",
    allow: OperationsData,
    element: <CompletedOperationsPage />
  },
  {
    path: "/search",
    allow: OperationsData,
    element: <GlobalSearchPage />
  }
];
